module.exports = __webpack_public_path__ + "static/media/workplace.a74f87f4.jpg";